import request from '@/utils/request'

export function getTableFullType() {
    return request({
        url: 'api/tableFullType',
        method: 'get'
    })
}


export function postTable(type, data) {
    return request({
        url: 'api/table/' + type,
        method: 'post',
        data
    })
}

export function putTable(type, data) {
    return request({
        url: 'api/table/' + type,
        method: 'put',
        data
    })
}


export function delTable(type, id) {
    return request({
        url: `api/table/${type}/${id}`,
        method: 'delete'
    })
}

export function edit(data) {
    return request({
        url: 'api/specifictraining',
        method: 'put',
        data
    })
}
